// In-memory store so Plot-2 selections survive tab switches. Plot2Tab is
// conditionally rendered in MessagePage, so leaving the tab UNMOUNTS it and its
// cells, losing all useState. Callers compose keys from the run (history) id + grid
// + cell index so different runs / grids / cells don't clobber each other. This is
// intentionally module-level (survives unmount) and NOT persisted to disk.
const store = {}

export const readPlot2 = (key) => (key && store[key]) || {}

export const writePlot2 = (key, patch) => {
    if (!key) return
    store[key] = {...(store[key] || {}), ...patch}
}
